import React from 'react';
import ServiceDetailTemplate from '../Elements/ServiceDetailTemplate';

const bnrimg = require('../../images/clients.jpg');
const productImg = require('../../images/Proyectos.png');

const ServiceDetailProyects = () => (
    <ServiceDetailTemplate
        moduleKey="proyectos"
        bnrimg={bnrimg}
        productImg={productImg}
    />
);

export default ServiceDetailProyects;
